<template>
  <div
    class="job-offer-list-item-wrapper border_1 border_med_gray py-4 px-1 px-md-2 px-lg-4"
  >
    <b-row class="v2_line_height_40">
      <b-col cols="12" md="2" class="d-flex align-items-center justify-content-center">
        <b-button
          variant="v2_link"
          class="font_size_1125rem"
          @click="toggleDetails"
        >
          {{ jobOffer ? jobOffer.title : '-- Unnamed --' }}
        </b-button>
      </b-col>
      <b-col
        cols="12"
        md="2"
        class="d-flex align-items-center justify-content-start"
        :class="{'justify-content-center': isMobile,'justify-content-md-center':!isMobile}"
        @click="toggleDetails"
      >
        {{ status }}
      </b-col>
      <b-col
        cols="12"
        md="2"
        offset-md="1"
        class="d-flex justify-content-start align-items-center mail-icon-wrapper"
        :class="{'justify-content-center': isMobile,'justify-content-md-center':!isMobile}"
      >
        <i
          class="mdi mdi-mailbox clickable"
          v-if="parseInt(numberOfUnviewedMessages) === 0"
          @click="openMessages"
        />
        <span
          class="d-flex align-items-center clickable"
          @click="openMessages"
          v-else
        >
          <i class="mdi mdi-mailbox-up" />
          <span class=""> ({{ numberOfUnviewedMessages }}) </span>
        </span>
      </b-col>
      <b-col
        cols="12"
        md="5"
        class="d-flex justify-content-start justify-content-md-end align-items-center mail-icon-wrapper"
      >
        <b-button
          variant="v3_teal_outline"
          class="ml-lg-4 mt-2 mt-lg-0"
          @click="handleContactRecruiter"
        >
          <template>Contact Recruiter</template>
        </b-button>
        <b-button
          v-if="!match.is_declined"
          variant="v3_teal_outline"
          class="ml-lg-4 mt-2 mt-lg-0 decline-match-button"
          :disabled="!!match.is_declined || isDeclineLoading"
          @click="onDeclineHandler"
        >
          <template v-if="!isDeclineLoading">Decline This Match</template>
          <template v-else>
            <b-spinner small />
          </template>
        </b-button>
        <b-button
          v-else
          variant="v3_teal_outline"
          class="ml-lg-4 mt-2 mt-lg-0 decline-match-button"
          :disabled="!match.is_declined || isDeclineLoading"
          @click="onUndeclineJobOffer"
        >
          <template v-if="!isDeclineLoading">Undecline This Match</template>
          <template v-else>
            <b-spinner small />
          </template>
        </b-button>
      </b-col>
    </b-row>
    <b-collapse
      :visible="isDetailsOpen"
      :id="collapseId"
      accordion="match-cards"
    >
      <job-profile-list-items-details
        :match="match"
        :job-profile="jobProfile"
        :view-mode="detailsViewMode"
        :mode="messageMode"
        :messages="messages"
        :is-messages-loading="isMessagesLoading"
        :job-questions="jobQuestions"
        @mark-as-read="handleMarkAsRead"
        @new-msg-created="handleNewMsgCreated"
        @open-new-msg="handleContactRecruiter"
        @close-message-list="handleCloseMessageList"
        @mode-changed="handleModeChange"
      />
    </b-collapse>
    <job-profile-job-offer-match-decline-modal
      v-if="isDeclineModalVisible"
      :visible="isDeclineModalVisible"
      @cancel="isDeclineModalVisible = false"
      @modal-close="isDeclineModalVisible = false"
      @continue="declineJobOffer"
    />
  </div>
</template>

<script>
import { JOB_OFFERS_MATCHING_STATUS_TITLES } from '@/store';
import JobProfileListItemsDetails from '@/components/exchange/job-profiles-list/JobProfileListItemsDetails';
import JobProfileJobOfferMatchDeclineModal from '@/components/exchange/job-profiles-list/JobProfileJobOfferMatchDeclineModal';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import Api from '@/providers/Api';
import { getNumberOfUnreadMessages } from '@/helpers/messagesHelper';
import Help from '@/providers/Help';
import MobileDetectionMixin from "@/mixins/MobileDetectionMixin";

export const VIEW_MODES = {
  COLLAPSED: 'COLLAPSED',
  DETAILS: 'DETAILS',
  MESSAGES: 'MESSAGES',
  NEW_MSG: 'NEW_MSG',
  VIEW_MSG: 'VIEW_MSG',
};

export default {
  name: 'JobProfileJobOfferListItem',
  props: {
    match: Object,
    jobProfile: Object,
    jobQuestions: Array,
  },
  mixins: [
    MobileDetectionMixin
  ],
  components: {
    JobProfileListItemsDetails,
    JobProfileJobOfferMatchDeclineModal,
  },
  countIntervalId: null,
  messagesIntervalId: null,
  data: function () {
    return {
      numberOfUnviewedMessages: this.match.numberOfUnviewedMessages || 0,
      messages: [],
      isDeclineLoading: false,
      isMessagesLoading: false,
      detailsViewMode: VIEW_MODES.COLLAPSED,
      messageMode: null,
      isDeclineModalVisible: false,
      viewedStatus: 'UNOPENED'
    };
  },
  created: function () {
    this.updateCountSubscription(true);
  },
  beforeDestroy: function () {
    if (this.$options.countIntervalId)
      clearInterval(this.$options.countIntervalId);
    if (this.$options.messagesIntervalId)
      clearInterval(this.$options.messagesIntervalId);
  },
  computed: {
    collapseId: function () {
      return `details-collapse-${this.match.id}`;
    },
    status: function () {
      return JOB_OFFERS_MATCHING_STATUS_TITLES[this.match.status];
    },
    jobOffer: function () {
      return this.match.jobOffer;
    },
    isDetailsOpen: function () {
      return this.detailsViewMode !== VIEW_MODES.COLLAPSED;
    },
    isMessagesOpen: function () {
      return [VIEW_MODES.MESSAGES, VIEW_MODES.NEW_MSG].includes(
        this.detailsViewMode
      );
    },
  },
  methods: {
    onDeclineHandler: function () {
      this.isDeclineModalVisible = true;
    },
    declineJobOffer: async function (checkedReasons, otherReason) {
      this.isDeclineLoading = true;
      try {
        await Api.declineJobOffer(this.match.id, checkedReasons, otherReason);
        this.$set(this.match, 'is_declined', 1);
        /// update viewed status ////
        this.updateStatus('DECLINED');

        this.$toasted.success('The Job Offer declined successfully', {
          duration: 3000,
        });
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      } finally {
        this.isDeclineLoading = false;
        this.isDeclineModalVisible = false;
      }
    },
    onUndeclineJobOffer: async function () {
      Help.confirm.show(
        'Are you sure you want to undecline the Job Offer?',
        'Undecline',
        () => {
          this.undeclineJobOffer();
        }
      );
    },
    undeclineJobOffer: async function () {
      this.isDeclineLoading = true;
      try {
        await Api.undeclineJobOffer(this.match.id);
        this.$set(this.match, 'is_declined', 0);

        this.updateStatus('OPENED');

        this.$toasted.success('The Job Offer undeclined successfully', {
          duration: 3000,
        });
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      } finally {
        this.isDeclineLoading = false;
        this.isDeclineModalVisible = false;
      }
    },
    getMessages: async function () {
      this.isMessagesLoading = true;
      try {
        const messages = await Api.getMessagesForMatchedOffer(this.match.id);
        this.messages = messages;
        this.numberOfUnviewedMessages = getNumberOfUnreadMessages(messages);
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.isMessagesLoading = false;
      }
    },
    updateStatus: async function(status){
      try {
        await Api.updateJobProfileJobOfferMatchStatus(this.match.id,status);
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } 
    },
    toggleDetails: function () {
      this.viewedStatus = 'OPENED';
      this.updateCountSubscription(true);
      this.updateMessagesSubscription(false);
      this.detailsViewMode =
        this.detailsViewMode === VIEW_MODES.DETAILS
          ? VIEW_MODES.COLLAPSED
          : VIEW_MODES.DETAILS;
      this.updateStatus(this.viewedStatus);

    },
    startMessagesMode: function () {
      if (!this.isMessagesOpen) {
        this.getMessages();
      }
      this.updateCountSubscription(false);
      this.updateMessagesSubscription(true);
    },
    openMessages: function () {
      this.startMessagesMode();
      this.detailsViewMode =
        this.detailsViewMode === VIEW_MODES.MESSAGES
          ? VIEW_MODES.COLLAPSED
          : VIEW_MODES.MESSAGES;
    },
    updateCountSubscription: function (isCreate = false) {
      if (isCreate && !this.$options.countIntervalId) {
        this.$options.countIntervalId = setInterval(async () => {
          this.numberOfUnviewedMessages =
            await Api.getMatchedOfferUnviewedCount(this.match.id);
        }, 1000 * 60);
      } else if (!isCreate && this.$options.countIntervalId) {
        clearInterval(this.$options.countIntervalId);
        this.$options.countIntervalId = null;
      }
    },
    updateMessagesSubscription: function (isCreate = false) {
      if (isCreate && !this.$options.messagesIntervalId) {
        this.$options.messagesIntervalId = setInterval(async () => {
          const messages = await Api.getMessagesForMatchedOffer(this.match.id);
          this.messages = messages;
          this.numberOfUnviewedMessages = getNumberOfUnreadMessages(messages);
        }, 1000 * 60);
      } else if (!isCreate && this.$options.messagesIntervalId) {
        clearInterval(this.$options.messagesIntervalId);
        this.$options.messagesIntervalId = null;
      }
    },
    handleMarkAsRead: async function (id) {
      try {
        const viewedDate = await Api.markMessageAsViewed(id);
        const index = this.messages.findIndex((message) => message.id === id);
        if (index === -1) return;
        this.$set(this.messages[index], 'to_first_viewed_date', viewedDate);
        if (this.numberOfUnviewedMessages > 0) {
          this.numberOfUnviewedMessages -= 1;
        }
      } catch (error) {
        process.env.NODE_ENV !== 'production' && console.error(error);
      }
    },
    handleNewMsgCreated: function (newMsg) {
      this.messages.unshift(newMsg);
    },
    handleContactRecruiter: function () {
      this.startMessagesMode();
      this.detailsViewMode = VIEW_MODES.NEW_MSG;
      this.messageMode = 'CREATE';

      /// update viewed status ////
      this.updateStatus('REVIEWED');

    },
    handleCloseMessageList: function () {
      this.detailsViewMode = VIEW_MODES.DETAILS;
    },
    handleModeChange: function (mode) {
      this.messageMode = mode;
    },
  },
  watch: {
    numberOfUnviewedMessages: function () {
      this.$emit('update-new-msg-count');
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../sass/variables_mixins';

.btn-v2_link {
  color: $phairify_v2_color_primary_teal !important;
  &:hover {
    color: $phairify_v2_color_primary_teal !important;
  }
}
.decline-match-button {
  background-color: #ffffff !important;
  color: $phairify_v2_color_primary_teal;
  &:hover {
    color: #ffffff !important;
    background-color: $phairify_v2_color_primary_teal !important;
  }
  border: 1px solid $phairify_v2_color_primary_teal;
  border-radius: 0;
}
</style>
